var _path, _path2, _path3, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpenActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    viewBox: "0 0 28 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39706 18.2592L4.54871 14.9697C3.52266 13.0885 3.27355 10.882 3.85534 8.82816C4.43713 6.7743 5.80298 5.03847 7.65701 3.99668C9.51105 2.95488 11.704 2.691 13.7608 3.2622C15.8176 3.8334 17.5727 5.19368 18.6459 7.0484L20.4943 10.3378",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9733 17.4502H1.85205V36.1083H27.9733V17.4502Z",
    fill: "#FFBF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2666 27.4012C18.1069 28.9951 16.5428 29.8889 14.9131 29.8889C13.2833 29.8889 11.7192 28.9951 10.5595 27.4012",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.31565,
    cy: 24.9134,
    r: 1.24387,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5105,
    cy: 24.9134,
    r: 1.24387,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenActive);
export default __webpack_public_path__ + "static/media/lock-open-active.ab17e14d1109b84160ce709379e7a60c.svg";
export { ForwardRef as ReactComponent };